export const BREAKS_VALIDATION_ERRORS = {
    OVERLAPPING_BREAKS: 'OVERLAPPING_BREAKS',
    INVALID_BREAK_TIMES: 'INVALID_BREAK_TIMES',
    INTERLEAVING_BREAK_WITH_CLOCK: 'INTERLEAVING_BREAK_WITH_CLOCK',
    BREAK_TIME_OUT_OF_CLOCK: 'BREAK_TIME_OUT_OF_CLOCK',
};

export const BREAK_STATUSES = {
    EMPLOYEE_IGNORED: 'EMPLOYEE_IGNORED',
    UNCONSUMED: 'UNCONSUMED',
    RECONSUMED: 'RECONSUMED',
    INVOLUNTARILY_UNCONSUMED: 'INVOLUNTARILY_UNCONSUMED',
    LATE_CONSUMED: 'LATE_CONSUMED',
    SHORT_LATE_CONSUMED: 'SHORT_LATE_CONSUMED',
    SHORT_CONSUMED: 'SHORT_CONSUMED',
    RUNNING: 'RUNNING',
    EMPLOYER_CONSUMED: 'EMPLOYER_CONSUMED',
    CONSUMED: 'CONSUMED',
    PENALTY_AUTOMATICALLY_ADDED: 'PENALTY_AUTOMATICALLY_ADDED',
    PENALTY_EMPLOYER_ADDED: 'PENALTY_EMPLOYER_ADDED',
    EMPLOYER_IGNORE: 'EMPLOYER_IGNORE',
    EMPLOYER_ADDED: 'EMPLOYER_ADDED',
    EMPLOYER_DELETED: 'EMPLOYER_DELETED',
    AUTOMATICALLY_IGNORED: 'AUTOMATICALLY_IGNORED',
    AUTOMATIC_ADD_TO_PAID_TIME: 'AUTOMATIC_ADD_TO_PAID_TIME',
    IGNORED_BY_WAIVER_ON_FILE: 'IGNORED_BY_WAIVER_ON_FILE',
    AUTOMATICALLY_IGNORED_BY_WAIVER_ON_FILE: 'AUTOMATICALLY_IGNORED_BY_WAIVER_ON_FILE',
    SYSTEM_IGNORE: 'SYSTEM_IGNORE',
}

export const TCAF_EMPLOYEE_STATUSES = {
    PENDING_EMPLOYEE_APPROVAL: 'PENDING_EMPLOYEE_APPROVAL',
    EMPLOYEE_PROTESTED: 'EMPLOYEE_PROTESTED',
    EMPLOYEE_APPROVED: 'EMPLOYEE_APPROVED',
    EMPLOYER_APPROVED: 'EMPLOYER_APPROVED',
    EMPLOYEE_ACKNOWLEDGED: 'EMPLOYEE_ACKNOWLEDGED',
}

export const BREAK_CATEGORY_CODE = {
    MEAL: 'MEAL',
    ORDINARY: 'ORDINARY',
    LACTATION: 'LACTATION',
};

export const BREAK_TYPE_CODE = {
    PAID: 'PAID',
    UNSCHEDULED_PAID: 'UNSCHEDULED_PAID',
    UNPAID: 'UNPAID',
    UNSCHEDULED_UNPAID: 'UNSCHEDULED_UNPAID',
    SPLIT_SHIFT: 'SPLIT_SHIFT',
    UNSCHEDULED: 'UNSCHEDULED',
};

export const BREAK_ORIGINAL_SOURCES = {
    SPLITTED: 'SPLITTED',
    CONVERSION: 'CONVERSION',
}

export const BREAK_TYPES = {
    ENTITLED: 'ENTITLED',
    ADDITIONAL: 'ADDITIONAL',
};

export const BREAK_ENGINES = {
    STATIC: 'STATIC',
    DYNAMIC: 'DYNAMIC',
}

export const BREAK_CATEGORIES = {
    [BREAK_CATEGORY_CODE.ORDINARY]: {
        code: BREAK_CATEGORY_CODE.ORDINARY,
        title: $filter('translate')('rest'),
        icon: 'fa-coffee',
        order: 1,
    },
    [BREAK_CATEGORY_CODE.MEAL]: {
        code: BREAK_CATEGORY_CODE.MEAL,
        title: $filter('translate')('meal'),
        icon: 'fa-cutlery',
        order: 2,
    },
    [BREAK_CATEGORY_CODE.LACTATION]: {
        code: BREAK_CATEGORY_CODE.LACTATION,
        title: $filter('translate')('lactation'),
        order: 3,
        icon: 'fa-solid fa-person-breastfeeding'
    },
};

export const BREAK_DESCRIPTION = {
    PAID_MEAL: $filter('translate')('Paid meal'),
    UNPAID_MEAL: $filter('translate')('Unpaid meal'),
    PAID_REST: $filter('translate')('Paid rest'),
    UNPAID_REST: $filter('translate')('Unpaid rest'),
    LACTATION: $filter('translate')('Lactation'),
    UNPAID_SPLIT: $filter('translate')('Unpaid split'),
};

export const BREAKS_MEAL_ORDER = {
    FIRST_MEAL: 'FIRST_MEAL',
    SECOND_MEAL: 'SECOND_MEAL',
}

export const ENABLEMENT_STATUSES = {
    ENABLED: 'ENABLED',
    DISABLED: 'DISABLED',
}

export const WAIVER_ON_FILE_STATUSES = {
    CONSENTED: 'CONSENTED',
    REJECTED: 'REJECTED',
}

export const BREAK_CONFIGURATION_KEYS = {
    UNSCHEDULED_PAID_MEAL: 'UNSCHEDULED_PAID_MEAL',
    UNSCHEDULED_UNPAID_MEAL: 'UNSCHEDULED_UNPAID_MEAL',
    UNSCHEDULED_PAID_ORDINARY: 'UNSCHEDULED_PAID_ORDINARY',
    UNSCHEDULED_UNPAID_ORDINARY: 'UNSCHEDULED_UNPAID_ORDINARY',
    PAID_LACTATION: 'PAID_LACTATION',
    UNPAID_LACTATION: 'UNPAID_LACTATION'
};

export const BREAK_CONFIGURATIONS = {
    [BREAK_CONFIGURATION_KEYS.UNSCHEDULED_PAID_MEAL]: {
        description: $filter('translate')('Paid Meal'),
        code: BREAK_CONFIGURATION_KEYS.UNSCHEDULED_PAID_MEAL,
        type: BREAK_TYPE_CODE.UNSCHEDULED_PAID,
        category: BREAK_CATEGORY_CODE.MEAL,
        icon: 'fa-cutlery'
    },
    [BREAK_CONFIGURATION_KEYS.UNSCHEDULED_UNPAID_MEAL]: {
        description: $filter('translate')('Unpaid Meal'),
        code: BREAK_CONFIGURATION_KEYS.UNSCHEDULED_UNPAID_MEAL,
        type: BREAK_TYPE_CODE.UNSCHEDULED_UNPAID,
        category: BREAK_CATEGORY_CODE.MEAL,
        icon: 'fa-cutlery'
    },
    [BREAK_CONFIGURATION_KEYS.UNSCHEDULED_PAID_ORDINARY]: {
        description: $filter('translate')('Paid Rest'),
        code: BREAK_CONFIGURATION_KEYS.UNSCHEDULED_PAID_ORDINARY,
        type: BREAK_TYPE_CODE.UNSCHEDULED_PAID,
        category: BREAK_CATEGORY_CODE.ORDINARY,
        icon: 'fa-coffee'
    },
    [BREAK_CONFIGURATION_KEYS.UNSCHEDULED_UNPAID_ORDINARY]: {
        description: $filter('translate')('Unpaid Rest'),
        code: BREAK_CONFIGURATION_KEYS.UNSCHEDULED_UNPAID_ORDINARY,
        type: BREAK_TYPE_CODE.UNSCHEDULED_UNPAID,
        category: BREAK_CATEGORY_CODE.ORDINARY,
        icon: 'fa-coffee'
    },
    [BREAK_CONFIGURATION_KEYS.PAID_LACTATION]: {
        description: $filter("translate")('Paid Lactation'),
        code: BREAK_CONFIGURATION_KEYS.PAID_LACTATION,
        type: BREAK_TYPE_CODE.PAID,
        category: BREAK_CATEGORY_CODE.LACTATION,
        icon: 'fa-solid fa-person-breastfeeding'
    },
    [BREAK_CONFIGURATION_KEYS.UNPAID_LACTATION]: {
        description: $filter("translate")('Unpaid Lactation'),
        code: BREAK_CONFIGURATION_KEYS.UNPAID_LACTATION,
        type: BREAK_TYPE_CODE.UNPAID,
        category: BREAK_CATEGORY_CODE.LACTATION,
        icon: 'fa-solid fa-person-breastfeeding'
    }
};

export const ACTION_SOURCES = {
    EMPLOYEE: 'EMPLOYEE',
    EMPLOYER: 'EMPLOYER',
    SYSTEM: 'SYSTEM',
}

export const BREAK_ACTIONS = {
    AUTO_IGNORE: 'AUTO_IGNORE',
    AUTO_DEDUCT: 'AUTO_DEDUCT',
    WAIVE: 'WAIVE'
}

export const BREAK_PENALTY_TYPES = {
    CA: 'CA',
    WA: 'WA'
}

export const BREAK_TIME_STATUSES = {
    EARLY: {
        code: 'EARLY',
        label: $filter('translate')('Early')
    },
    LATE: {
        code: 'LATE',
        label: $filter('translate')('Late')
    },
    SHORT: {
        code: 'SHORT',
        label: $filter('translate')('Short')
    },
    ON_TIME: {
        code: 'ON_TIME',
        label: $filter('translate')('On time')
    }
}

export const BREAK_ATTESTATION_REASONS = {
    PERSONAL: {
        code: 'PERSONAL',
        label: $filter("translate")('Personal')
    },
    MANAGER_REQUEST: {
        code: 'MANAGER_REQUEST',
        label: $filter("translate")('Manager')
    },
    NONE: {
        code: 'NONE'
    }
}

export const BREAK_WAIVE_STATUS = {
    UNWAIVED: {
        code: 'UNWAIVED',
        label: $filter('translate')('involuntarily')
    },
    WAIVED: {
        code: 'WAIVED',
        label: $filter('translate')('voluntarily')
    }
}